import React from 'react'
import {FormattedMessage} from 'react-intl'
import moment from 'moment'

import LikeButton from './LikeButton'
import Price from './Price'
import Spacer from './Spacer'
import Icon from './Icon'

const estateDescriptionContainer = {
  display:'flex',
  flexDirection:'column'
}

const estateDescriptionRow = {
  display: 'flex',
  justifyContent: 'left'
}

const EstateDescription = ({id, address, price, rooms, partner, like, providerUrl, detailsUrl, features, proximityScore}) => {
  const proximity = moment.duration(proximityScore, 'seconds').humanize()
  const now = new Date()
  
  const bathrooms = (features && features.bathRooms) || 0;
  
  return <div style={estateDescriptionContainer}>
    
    <div style={estateDescriptionRow}>
      {address}
    </div>
    <div style={estateDescriptionRow}>
    {proximityScore != 0 ? <FormattedMessage 
        id="At X from your points of interest" 
        defaultMessage="At {proximity} from you points of interest" 
        values={{proximity}}/> : null}
    </div>
    <div style={estateDescriptionRow}>
      {(bathrooms != 0 || rooms != 0) ?
        <table> 
            <tbody>      
            <tr>
                {rooms != 0 ? 
                    <td style={{minWidth:'100px'}}>
                    <Icon name="bed">
                        <FormattedMessage 
                        id="nb rooms" 
                        defaultMessage="{rooms, plural, =0 {no rooms} one {one room} other {# rooms}}" 
                        values={{rooms}}/>
                    </Icon>
                    </td>
                    : null
                }
                {bathrooms != 0 ?
                    <td>
                    <Icon name="bath">
                        <FormattedMessage 
                        id="nb bathrooms" 
                        defaultMessage="{bathrooms, plural, =0 {no bathrooms} one {one bathroom} other {# bathrooms}}"
                        values={{bathrooms}}/>
                    </Icon>
                    </td>
                    : null
                }
            </tr>
            </tbody>
        </table>
        : null}
    </div>

  </div>;
}

EstateDescription.propTypes = {
  like: React.PropTypes.bool,
  address: React.PropTypes.string.isRequired,
  price: React.PropTypes.number.isRequired,
  rooms: React.PropTypes.number.isRequired,
  partner: React.PropTypes.string.isRequired,
  providerUrl: React.PropTypes.string.isRequired,
  detailsUrl: React.PropTypes.string.isRequired,
  features: React.PropTypes.object,
  proximityScore: React.PropTypes.number.isRequired,
}
export default EstateDescription



/** WEBPACK FOOTER **
 ** ./app/components/EstateDescription.jsx
 **/